// Sincroniza auth entre pestañas del mismo origen vía BroadcastChannel
// (token en memoria, TOKEN_UPDATED / TOKEN_REQUEST / LOGOUT).
const CHANNEL_NAME = 'torre-auth'
const PEER_RESPONSE_WAIT_MS = 120

const channel =
  typeof globalThis.BroadcastChannel === 'function'
    ? new globalThis.BroadcastChannel(CHANNEL_NAME)
    : null

const listeners = new Set()

channel?.addEventListener('message', ({ data }) => {
  listeners.forEach((listener) => listener(data))
})

export function publishAuthEvent(event) {
  channel?.postMessage(event)
}

export function subscribeAuthEvents(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function requestAccessTokenFromPeers() {
  if (!channel) return Promise.resolve(null)

  const requestId = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`

  return new Promise((resolve) => {
    const responses = []
    const unsubscribe = subscribeAuthEvents((event) => {
      if (event?.type !== 'TOKEN_RESPONSE' || event.requestId !== requestId) return
      if (event.token) responses.push(event)
    })

    publishAuthEvent({ type: 'TOKEN_REQUEST', requestId })

    globalThis.setTimeout(() => {
      unsubscribe()
      const newest = responses.sort((left, right) => right.updatedAt - left.updatedAt)[0]
      resolve(newest || null)
    }, PEER_RESPONSE_WAIT_MS)
  })
}
